const article = {
    slug: "first_maison_margiela_experience",
    category: "BRAND ENTRY",
    title: "初めてのMaison Margiela｜メゾンマルジェラをレンタル体験",
    listDescription:
      "解体、再構築、匿名性。Maison Margielaを“着ること”から理解する入口ページ。",
    seo: {
      title:
        "初めてのMaison Margiela｜メゾンマルジェラをレンタル体験｜マルジェラの魅力を着て知るEnclopedia",
      description:
        "Maison Margielaが気になるけれど、どんなブランドか分からない方へ。解体・再構築、匿名性、Tabi、アーティザナルなど、メゾンマルジェラの魅力を分かりやすく解説し、Enclopediaでレンタルできるアーカイブへ案内します。",
      keyword:
        "初めてのメゾンマルジェラ,メゾンマルジェラ 初めて,マルジェラ 初めて,マルジェラ 初心者,メゾンマルジェラ とは,マルジェラ どんなブランド,マルジェラ レンタル,Maison Margiela レンタル,マルジェラ 着てみたい,マルジェラ アーカイブ,Maison Margiela アーカイブ,enclopedia,アンクロペディア",
      canonicalPath: "/archive_guide/first_maison_margiela_experience",
    },
    hero: {
      label: "FIRST MAISON MARGIELA EXPERIENCE",
      number: "03 / ENTRY",
      titleLines: ["初めての", "Maison Margielaをレンタル体験。"],
      body:
        "一見すると静かでミニマル。\nけれど近づくと、縫い代、裏側、既製服の形そのものが少しずつずれている。\nMaison Margielaを初めて知るなら、まずは“着ることで分かる違和感”から入るのが自然です。",
      keywords: [
        "first experience",
        "deconstruction",
        "anonymity",
        "maison margiela",
      ],
      visualLabel: "ARCHIVE EXPERIENCE",
      visualTitle: ["見慣れた服の中に、", "構造の違和感を見つける。"],
      image: "media/archive_fashion/archive_guide4.png",
      imageAlt:
        "初めてのMaison Margielaをレンタル体験するためのアーカイブガイド画像",
      ctaLabel: "レンタルできるMaison Margielaを見る",
      ctaHref:
        "https://www.enclopedia-official.com/brand/MAISON%20MARGIELA（メゾンマルジェラ）/?number=47",
    },
    thesis: {
      text:
        "Maison Margielaは、服の“完成形”を疑うことで、日常着の見え方を更新するブランドです。",
      keywords: ["deconstruction", "everyday clothes", "experience"],
    },
    sections: {
      whyThisPage: {
        label: "02 / WHY THIS PAGE?",
        titleLines: [
          "マルジェラが気になる。",
          "でも、Tabiや4ステッチ以外はまだよく分からない。",
        ],
        body:
          "Maison Margielaは、名前だけは知っていても、何が特別なのかを説明しづらいブランドの一つです。\nTabiブーツや4ステッチは有名ですが、本質はそこだけではありません。\nこのページでは、マルジェラを“難解な前衛ブランド”ではなく、“見慣れた服の見方を変えるブランド”として整理します。",
      },
  
      brandOverview: {
        label: "03 / BRAND OVERVIEW",
        titleLines: [
          "完成された服を壊すのではなく、",
          "服の成り立ちを見せる。",
        ],
        body:
          "Maison Margielaは、縫い代、裏地、仮縫い、古着、既製服といった通常は隠れる要素を表へ引き出し、服の構造そのものを見せてきたブランドです。\nその結果、日常的なジャケットやパンツでさえ、少し違う角度から見えるようになる。\nマルジェラの魅力は、“奇抜さ”よりも、普通の服の見え方を静かに揺らすところにあります。",
        knowledgeItems: [
          {
            title: "解体は、壊すことではなく読むこと。",
            text:
              "裏地や縫製、服が成立するまでの痕跡をあえて見せることで、当たり前だった服の構造を読み直します。",
          },
          {
            title: "匿名性は、服そのものを前に出すための方法。",
            text:
              "派手なロゴや作者の顔を強調する代わりに、服そのものの存在感を際立たせる。匿名性はマルジェラの重要な視点です。",
          },
          {
            title: "日常着を出発点にしているから、入口がある。",
            text:
              "ジャケット、シャツ、パンツ、スニーカーなど、見慣れた衣服を土台にしながら、その意味を少しずつずらしていきます。",
          },
          {
            title: "アーカイブで見ると、思想の変化が分かる。",
            text:
              "過去作を追うと、脱構築、匿名性、再利用、手仕事といった考え方が、時期ごとにどのように形になったかが見えてきます。",
          },
        ],
      },
  
      lineGuide: {
        label: "04 / HOW TO SEE MARGIELA?",
        titleLines: [
          "Maison Margielaを見るなら、",
          "まず4つの視点から。",
        ],
        items: [
          {
            tag: "ENTRY 01",
            title: "DECONSTRUCTION",
            text:
              "縫い代、裏地、切替、仮縫い。服の内側を表に出し、“完成された服”という前提を揺さぶります。",
          },
          {
            tag: "ENTRY 02",
            title: "ANONYMITY",
            text:
              "4ステッチや白いタグに象徴される匿名性。ブランドを誇示するのではなく、服の存在を前面に出します。",
          },
          {
            tag: "ENTRY 03",
            title: "EVERYDAY RE-READING",
            text:
              "ジャケットやパンツ、コートのような日常着を、少しのずれや再構成によってまったく違う服に見せます。",
          },
          {
            tag: "ENTRY 04",
            title: "HOUSE CODES",
            text:
              "Tabi、Artisanal、Bianchettoなど、ブランドの象徴的なコードを知ると、作品の読み方が一段深まります。",
          },
        ],
      },
  
      firstExperience: {
        label: "05 / FIRST EXPERIENCE",
        titleLines: ["初めて着ると、", "何が分かるのか。"],
        intro:
          "Maison Margielaの服は、写真で見たときより、身体に乗せた瞬間に“なぜこの形なのか”が理解しやすくなります。",
        items: [
          {
            index: "01",
            title: "一見シンプルなのに、細部に違和感がある",
            text:
              "ポケットの位置、切替線、丈のバランス、縫製の見せ方。目立つ装飾がなくても、服の輪郭に小さな異物感が残ります。",
          },
          {
            index: "02",
            title: "身体の整え方が、普通の服と少し違う",
            text:
              "身体をきれいに見せるためだけではなく、身体と服の距離そのものを再設計する。その感覚は着用時に最も分かりやすく現れます。",
          },
          {
            index: "03",
            title: "定番とアーカイブの見え方が変わる",
            text:
              "Tabiや4ステッチだけでなく、過去のジャケット、パンツ、再構築された衣服を見る目が変わります。“なぜ残るのか”を体験として理解できます。",
          },
        ],
      },
  
      quote: {
        textLines: [
          "目立つための服ではなく、",
          "見え方を変えるための服。",
        ],
      },
  
      whyRent: {
        label: "06 / WHY RENT?",
        titleLines: ["初めてのマルジェラほど、", "レンタルで理解が深まる。"],
        items: [
          {
            number: "01",
            title: "写真では、構造の面白さが伝わりきらない",
            text:
              "素材の厚み、縫製の痕跡、立体感、着たときの余白。マルジェラは実物で見るほど理解が進むブランドです。",
          },
          {
            number: "02",
            title: "日常に入るかを確かめられる",
            text:
              "前衛的に見える服でも、実際に着ると意外に生活へ馴染むことがあります。レンタルはその距離を測る手段になります。",
          },
          {
            number: "03",
            title: "定番を“消費”せず、背景ごと体験できる",
            text:
              "有名だから選ぶのではなく、なぜ評価されてきたのかを、着用を通じて確かめられます。",
          },
        ],
      },
  
      inventory: {
        label: "07 / AVAILABLE ARCHIVE",
        titleLines: ["Enclopediaで", "体験できるMaison Margiela。"],
        body:
          "実在庫への導線は、“マルジェラを知る続き”として設計します。まず背景を理解し、次に実物で確かめる流れを作ります。",
        items: [
          {
            meta: "MAISON MARGIELA / 2024SS",
            title: "ワイドハーフパンツ",
            text:
              "一見シンプルなボトムスの中に、分量感とシルエットのずれが残るMaison Margielaらしい一着。",
            href:
              "https://www.enclopedia-official.com/product/33889388-65dc-4d96-a3a7-388346529a6b",
            image:
              "media/product/1762182245.869212933889388-65dc-4d96-a3a7-388346529a6b.jpg",
          },
        ],
      },
  
      faq: {
        label: "08 / FAQ",
        titleLines: ["初めての人が、", "気になりやすいこと。"],
        items: [
          {
            question: "Maison Margielaは、どんなブランドですか？",
            answer:
              "既存の服の構造や価値観を問い直してきたブランドです。解体、再構築、匿名性、手仕事といった視点が重要になります。",
          },
          {
            question: "初めてなら、どのアイテムから見るのがおすすめですか？",
            answer:
              "ジャケット、パンツ、シャツなど、日常着に近い形式を持ちながら、どこかに違和感が残るアイテムがおすすめです。",
          },
          {
            question: "Tabiやバッグ以外の服もレンタルできますか？",
            answer:
              "はい。Enclopediaでは衣服のアーカイブ体験を重視しており、ジャケットやパンツなどのウェアも扱います。",
          },
          {
            question: "レンタル後に購入もできますか？",
            answer:
              "対象アイテムは、レンタル体験を経たうえで購入相談へ進める導線を想定しています。",
          },
        ],
      },
  
      finalCta: {
        titleLines: [
          "初めてのMaison Margielaを、",
          "レンタルから始める。",
        ],
        body:
          "難しそうに見える服ほど、実際に着ることで意味が近くなる。\nEnclopediaで、マルジェラのアーカイブを体験してください。",
        buttonLabel: "レンタルできるMaison Margielaを見る",
        buttonHref:
          "https://www.enclopedia-official.com/brand/MAISON%20MARGIELA（メゾンマルジェラ）/?number=47",
      },
    },
  };

export default article;
